export const MULTI_SELECTION_REFERENCE_TYPE = "multi-selection"
